<template>
  <div>
    <div class="scrollCardUeberMich-1">
      <div class="container">
        <div class="scrollContentTitle">
          <h6 class="title title-up text-center navHeadline">Über mich</h6>
          <h4 class="text-center title navHeadlineText text-white">Erfahren Sie mehr über meine Ansätze und meine Qualifikationen</h4>
        </div>

        <div class="row justify-content-between h-auto">
          <div class="align-self-center col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="text-center">
              <p class="text text-white">
                "Ich lege keinen Wert auf's schnelle Abfertigen. Der Austausch mit Ihnen, sowie eine ausführliche und
                gründliche Pediküre steht bei mir im Vordergrund."
              </p>
              <hr>
              <h2 class="title headlineAnjaBender text-white">Anja Bender</h2>
            </div>

          </div>
          <!--<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center h-50">-->
            <img v-lazy="'img/anja2.png'" alt="Anja" class="col-lg-6 rounded mx-auto d-block"/>
          <!--</div>-->
        </div>
      </div>
    </div>

    <div class="scrollCardUeberMich-2">
      <div class="container">

      Qualifikation
      </div>
    </div>
  </div>

  <!--</template>-->
  <!--</scroll-content>-->
</template>

<script>
//import {ScrollContent} from '@/components';

export default {
  name: "UeberMich"
  /*components: {
    ScrollContent
  }*/
}
</script>

<style scoped>
.headlineAnjaBender {
  margin-top: 30px;
}
.text{
  font-size: 22px;
  font-style: oblique;
}
hr{
  border-top: 1px solid;
}
</style>